import { CasinoActionConstants } from "../action-constants";

const { SET_IS_SIC, SET_GAMBLING_SESSION } = CasinoActionConstants;

const setIsSIC = isSIC => ({ type: SET_IS_SIC, payload: isSIC });
const setGamblingSession = gamblingSession => ({
  type: SET_GAMBLING_SESSION,
  payload: gamblingSession
});

export default {
  setIsSIC,
  setGamblingSession
};
